const CTASection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/48479614c07fce6cafefc9a99a1fe76f.jpg"
          alt="Transform Your IT"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/60 via-slate-900/40 to-slate-900/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 w-full">
        <div className="flex flex-col justify-between min-h-[60vh]">
          <div className="max-w-4xl">
            <h2 className="text-5xl lg:text-7xl font-bold text-white leading-tight mb-8">
              Ready to Transform Your IT Infrastructure?
            </h2>
          </div>

          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-8">
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/contact')}
              className="group flex items-center bg-white rounded-full overflow-hidden shadow-2xl hover:shadow-cyan-500/50 transition-all whitespace-nowrap cursor-pointer"
            >
              <span className="px-10 py-5 text-lg font-bold text-slate-900">
                Get Started
              </span>
              <div className="w-14 h-14 flex items-center justify-center bg-slate-900 group-hover:bg-cyan-500 transition-colors">
                <i className="ri-arrow-right-line text-white text-2xl"></i>
              </div>
            </button>

            <div className="text-white space-y-1">
              <p className="text-xl lg:text-2xl font-light">
                Join 500+ enterprises trusting us
              </p>
              <p className="text-xl lg:text-2xl font-light">
                with their IT operations
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;